import { render, staticRenderFns } from "./createPattern.vue?vue&type=template&id=06d47447"
import script from "./createPattern.vue?vue&type=script&lang=js"
export * from "./createPattern.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports